import { defineMessages } from 'react-intl';

export default defineMessages({
    edit: {
        id: 'ml.quoteandbind.pa.scrollingtable.edit',
        defaultMessage: 'Edit'
    },
    remove: {
        id: 'ml.quoteandbind.pa.scrollingtable.remove',
        defaultMessage: 'Remove'
    },
    month: {
        id: 'ml.quoteandbind.pa.scrollingtable.month',
        defaultMessage: 'month'
    },
    sevenDays: {
        id: 'ml.quoteandbind.pa.scrollingtable.sevenDays',
        defaultMessage: '7 Days'
    },
    sixMonth: {
        id: 'ml.quoteandbind.pa.scrollingtable.sixMonth',
        defaultMessage: '6 months'
    },
    yr: {
        id: 'ml.quoteandbind.pa.scrollingtable.yr',
        defaultMessage: 'yr'
    }
});
